var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "share-07"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M5.72667 9.50634L10.28 12.1597M10.2733 4.83967L5.72667 7.49301M14 3.83301C14 4.93758 13.1046 5.83301 12 5.83301C10.8954 5.83301 10 4.93758 10 3.83301C10 2.72844 10.8954 1.83301 12 1.83301C13.1046 1.83301 14 2.72844 14 3.83301ZM6 8.49967C6 9.60424 5.10457 10.4997 4 10.4997C2.89543 10.4997 2 9.60424 2 8.49967C2 7.39511 2.89543 6.49967 4 6.49967C5.10457 6.49967 6 7.39511 6 8.49967ZM14 13.1663C14 14.2709 13.1046 15.1663 12 15.1663C10.8954 15.1663 10 14.2709 10 13.1663C10 12.0618 10.8954 11.1663 12 11.1663C13.1046 11.1663 14 12.0618 14 13.1663Z",
    stroke: "#4037acd6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.17cb53c48af69504d22625263813592a.svg";
export { ForwardRef as ReactComponent };